export default __webpack_public_path__ + "static/media/zoom-out.82a582f7.svg";